import React from 'react';
import { FiMapPin } from 'react-icons/fi';
import {
  SiJavascript, SiReact, SiNodedotjs, SiTypescript,
  SiDotnet, SiPhp, SiUnity, SiBlender, SiHtml5, SiCsswizardry,
} from 'react-icons/si';
import styles from './About.module.css';
import { useLanguage } from '../../context/LanguageContext';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const skills = [
  { name: 'JavaScript', years: '8yr', icon: SiJavascript },
  { name: 'React / React Native', years: '6yr', icon: SiReact },
  { name: 'HTML / CSS', years: '8yr', icon: SiHtml5 },
  { name: 'Node.js', years: '', icon: SiNodedotjs },
  { name: 'TypeScript', years: '', icon: SiTypescript },
  { name: '.NET Framework', years: '', icon: SiDotnet },
  { name: 'PHP / MySQL', years: '3yr', icon: SiPhp },
  { name: 'Unity3D / WebGL', years: '3-4yr', icon: SiUnity },
  { name: '3D Modeling', years: '', icon: SiBlender },
  { name: 'CSS / Sass', years: '', icon: SiCsswizardry },
];

const About: React.FC = () => {
  const { t } = useLanguage();
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="about" className={`section ${styles.about}`}>
      <div className="container">
        <div className={`section-header fade-in ${isVisible ? 'visible' : ''}`}>
          <span className="section-tag">{t.about.subtitle}</span>
          <h2 className="section-title">{t.about.title}</h2>
        </div>

        <div
          ref={ref as React.RefObject<HTMLDivElement>}
          className={`${styles.grid} fade-in ${isVisible ? 'visible' : ''}`}
        >
          <div className={styles.textBlock}>
            <p>{t.about.description}</p>
            <p className={styles.meta}>
              <FiMapPin className={styles.metaIcon} />
              <strong>{t.about.locationLabel}:</strong> {t.about.location}
            </p>
          </div>

          <div className={styles.skillsBlock}>
            <h3 className={styles.skillsTitle}>{t.about.skillsTitle}</h3>
            <div className={styles.skillsList}>
              {skills.map(skill => (
                <div key={skill.name} className={styles.skill}>
                  <skill.icon className={styles.skillIcon} />
                  <span>{skill.name}</span>
                  {skill.years && (
                    <span className={styles.skillYears}>{skill.years}</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
